export { default as PulseSlider } from './PulseSlider';
